module.exports = __webpack_public_path__ + "static/media/srh-logo.21bcd00a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo/srh-logo.svg
// module id = 1440
// module chunks = 0